export const convertEntityGlobalIdsToIds = (
  entityMap: Record<string, { id: number }>,
  globalIds: Array<string>
): Array<number> => globalIds.map((globalId) => entityMap[globalId].id);
